import type { DevSettings } from '../../utils/devSettings/devSettings.types';

export type ENVIRONMENT_CONFIG = {
  devSettings: DevSettings;
  name: string;
  /**
   * Describes how to find the environment in the Dynamic Dashboard
   */
  source: {
    deployMode: 'live' | 'sandbox';
    organization: string;
    project: string;
  };
};

const defaultEnabledExtensions: DevSettings['extensions'] = {
  aptos: true,
  bitcoin: true,
  evm: true,
  phantomRedirectSolana: true,
  solana: true,
  starknet: true,
  sui: true,
  tron: true,
  walletConnectEvm: true,
  walletConnectSolana: true,
  zerodev: true,
};

export const DEFAULT_VANILLA_ENVIRONMENT_CONFIG: ENVIRONMENT_CONFIG = {
  devSettings: {
    apiBaseUrlOrigin: 'https://app.dynamic-preprod.xyz/',
    apiBaseUrlPath: 'api/v0/',
    environmentId: 'cc202c08-f9cd-4692-9167-92f3da1d57f0',
    extensions: defaultEnabledExtensions,
  },
  name: 'Default Vanilla development (sandbox)',
  source: {
    deployMode: 'sandbox',
    organization: 'Dynamic-Preprod',
    project: 'Default Demo Vanilla',
  },
};

const DEFAULT_DEMOV2_ENVIRONMENT_CONFIG: ENVIRONMENT_CONFIG = {
  devSettings: {
    apiBaseUrlOrigin: 'https://app.dynamic-preprod.xyz/',
    apiBaseUrlPath: 'api/v0/',
    environmentId: '83bee83b-81e0-44c3-843c-435ab186f470',
    extensions: defaultEnabledExtensions,
  },
  name: 'Default development',
  source: {
    deployMode: 'live',
    organization: 'Dynamic-Preprod',
    project: 'Default Demo V2',
  },
};

const HCAPTCHA_ENABLED_CONFIG: ENVIRONMENT_CONFIG = {
  devSettings: {
    apiBaseUrlOrigin: 'https://app.dynamic-preprod.xyz/',
    apiBaseUrlPath: 'api/v0/',
    environmentId: '89302b1d-3deb-4a3c-ba99-b2ea1da9bb36',
    extensions: defaultEnabledExtensions,
  },
  name: 'Default Vanilla development (live)',
  source: {
    deployMode: 'live',
    organization: 'Dynamic-Preprod',
    project: 'Default Demo Vanilla',
  },
};

const MFA_OPTIONAL_ENVIRONMENT_CONFIG: ENVIRONMENT_CONFIG = {
  devSettings: {
    apiBaseUrlOrigin: 'https://app.dynamic-preprod.xyz/',
    apiBaseUrlPath: 'api/v0/',
    environmentId: '83ec992b-bcd4-4508-a023-3910b0613287',
    extensions: defaultEnabledExtensions,
  },
  name: 'MFA optional',
  source: {
    deployMode: 'sandbox',
    organization: 'Gui',
    project: 'MFA Optional',
  },
};

export const PREBAKED_ENVIRONMENTS: ENVIRONMENT_CONFIG[] = [
  DEFAULT_VANILLA_ENVIRONMENT_CONFIG,
  DEFAULT_DEMOV2_ENVIRONMENT_CONFIG,
  MFA_OPTIONAL_ENVIRONMENT_CONFIG,
  HCAPTCHA_ENABLED_CONFIG,
];
